/** Default API base when REACT_APP_API_URL is unset (e.g. production SMS receipt links). */
export const DEFAULT_API_URL = 'https://backendofduesaccountant.winswardtech.com/api';

export const getApiBaseUrl = () =>
  (process.env.REACT_APP_API_URL || DEFAULT_API_URL).replace(/\/$/, '');
